import { observable, computed } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';

class AppointmentSuccessModalStore extends BaseModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable email = '';

  @observable discordLink = undefined;
  @observable youtubeLink = undefined;
  @observable twitterLink = undefined;
  @computed
  get itemList() {
    return [
      {
        name: 'Discord',
        link: this.discordLink,
        // img: require(''),
        onClick() { }
      },
      {
        name: 'YouTube',
        link: this.youtubeLink,
        // img: require(''),
        onClick() { }
      },
      {
        name: 'X (Twitter)',
        link: this.twitterLink,
        // img: require(''),
        onClick() { }
      }
    ];
  }

  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      window.open(url);
    }
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  use() {
    super.use();
  }
}

export default AppointmentSuccessModalStore;
